import { createAction } from 'redux-starter-kit';
import api from 'api/home';

export const fetchCompoundBundles = createAction('home/FETCH_START');
export const fetchCompoundBundlesSuccess = createAction('home/FETCH_SUCCESS');
export const fetchCompoundBundlesFailure = createAction('home/FETCH_FAILURE');

export const cacheSettings = createAction('home/CACHE_SETTINGS');
export const clearResults = createAction('home/CLEAR_RESULTS');

export const searchFor = createAction('home/SEARCH');
export const setSearchFor = createAction('home/SET_SEARCH');

export const asyncFetchCompoundBundles = () => async (dispatch, getState) => {
  // determine if there is any change in state that would trigger a fetch
  const { isLoading, searchFor, prevState } = getState().home;
  const settingsDifferent = JSON.stringify({ searchFor }) !== prevState;

  if (!isLoading && settingsDifferent) {
    dispatch(clearResults());
    dispatch(fetchCompoundBundles());
    api
      .fetchCompoundBundles(paramsFromState(getState()))
      .then(results => {
        dispatch(fetchCompoundBundlesSuccess(results));

        dispatch(cacheSettings());
      })
      .catch(error => dispatch(fetchCompoundBundlesFailure({ error: error.message })));
  }
};

export const asyncSearchForHome = term => async dispatch => {
  dispatch(searchFor(term));
  dispatch(asyncFetchCompoundBundles());
};

export const changeSearchForHome = term => async dispatch => {
  dispatch(setSearchFor(term));
};

const paramsFromState = state => {
  const { searchFor } = state.home;
  return {
    search_for: searchFor
  };
};
